import { CorpSessionMapper } from "@/adapters/CorpSession.mapper";
import { supabase } from "@/utils/supabase";
/**
 * Ошибка сессии корп-админа. `code` — код PostgREST (например, "42501" —
 * заблокированный/удалённый админ или отсутствие компаний).
 */
export class CorpSessionError extends Error {
    constructor(code, message, status = null) {
        super(message);
        this.name = "CorpSessionError";
        this.code = code;
        this.status = status;
    }
}
export class CorpSessionService {
    async whoami() {
        // Литерал process.env.* подставляется при сборке (см. utils/featureFlags.ts): при
        // REACT_APP_B2B_MOCK='false' (prod, G4) webpack выбрасывает ветку целиком — мок не попадает в бандл.
        if (process.env.REACT_APP_B2B_MOCK === "true") {
            const { CorpSessionServiceMock } = await import("@/services/corp/CorpSessionServiceMock");
            // Вариант фикстуры для ручного QA: sessionStorage `corp.mockWhoami` = "multi" (пять компаний, CCR-037).
            let variant = "single";
            try {
                if (window.sessionStorage.getItem("corp.mockWhoami") === "multi")
                    variant = "multi";
            }
            catch {
                // хранилище недоступно — одиночная компания
            }
            return new CorpSessionServiceMock(variant).whoami();
        }
        const { data, error, status } = await supabase().rpc("corp_whoami");
        if (error) {
            throw new CorpSessionError(error.code ?? null, error.message, status ?? null);
        }
        return CorpSessionMapper.toDomain(data);
    }
}
export const corpSessionService = new CorpSessionService();
